import {
  OtsEntityIdentitySelect,
  type OtsEntityIdentitySelectProps,
} from './OtsEntityIdentitySelect';
export type OtsLocationSelectProps = Omit<
  OtsEntityIdentitySelectProps,
  'entityType' | 'entityName' | 'entityTypes' | 'label'
> & { locationType: string; locationName?: string };
export const OtsLocationSelect = ({
  locationType,
  locationName,
  ...props
}: OtsLocationSelectProps) => (
  <OtsEntityIdentitySelect
    {...props}
    entityType={locationType}
    entityName={locationName}
    label="Location"
    entityTypes={[
      { value: 'SITE', label: 'Site' },
      { value: 'WELL', label: 'Well' },
    ]}
  />
);
